import { booleanAttribute, computed, Directive, input } from '@angular/core';
import type { ContextFamily, ContextTone } from '@quipex/shared/utils';
import { resolveTypographyClass } from './color';

@Directive({
    selector: '[qpxHeading]',
    host: {
        '[class]': 'className()',
    },
})
export class QpxHeading {
    public readonly context = input<
        ContextFamily | undefined,
        ContextFamily | '' | undefined
    >(undefined, {
        alias: 'qpxHeading',
        transform: (value) => value || undefined,
    });

    public readonly tone = input<ContextTone>('default');
    public readonly decorative = input(false, { transform: booleanAttribute });

    public readonly variant = input<'sm' | 'md' | 'lg' | 'xl'>('md');

    protected readonly className = computed(() => {
        let text = '';
        switch (this.variant()) {
            case 'sm':
                text = 'text-heading-sm';
                break;
            case 'md':
                text = 'text-heading-md';
                break;
            case 'lg':
                text = 'text-heading-lg';
                break;
            case 'xl':
                text = 'text-heading-xl';
                break;
        }

        return [
            text,
            'm-0',
            resolveTypographyClass(
                this.context(),
                this.tone(),
                this.decorative()
            ),
        ].join(' ');
    });
}
